import * as types from "../constants/ActionTypes"

export const setFilterNps = (to, value) => ({
    type: types.CHANGE_FILTERS_NPS,
    to,
    value
})